import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MeasurementPonitsService } from '../services/measurement-points-service';
import { LoadingService } from '../../../shared/services/loading.service';
import { CreateMeasurementPointsComponentComponent } from '../create-measurement-points-component/create-measurement-points-component.component';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { MeasurementToolsViewModel, MeasurementPointsViewModel, CalculationMethod} from '../model/measurement-points.model';
import { TranslateService } from '../../../translate';
import { CalculationMethodFormsComponent } from './calculation-method-forms/calculation-method-forms.component';
import { Tuple } from '../../../entities';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-edit-measurement-points-component',
  templateUrl: './edit-measurement-points-component.component.html',
  styleUrls: ['./edit-measurement-points-component.component.scss'],
})
export class EditMeasurementPointsComponentComponent implements AfterViewInit {
  private _subscriptions: Subscription[] = [];

  editingMeasurementPoint: MeasurementPointsViewModel;
  selectedCalculationMethodId: number;
  selectedCalculationMethodObj: CalculationMethod;
  makeId: number;
  selectedToolId: number;
  allCalMethods: CalculationMethod[];
  addedTools: MeasurementToolsViewModel[] = [];
  trackTools: MeasurementToolsViewModel[];

  @ViewChild('all')
  allCalculations: CalculationMethodFormsComponent;

  constructor(
    private _measurementPointsService: MeasurementPonitsService,
    private _loading: LoadingService,
    public dialogRef: MatDialogRef<CreateMeasurementPointsComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
    private _translate: TranslateService

  ) { }

  isLoading: boolean;
  saving = false;
  savingAll(isSaving: boolean) {
    this.saving = isSaving;
  }

  savedAll(result: Tuple) {
    console.log(result);
    this.saving = false;
     if (result.m_Item1 > 0) {
        this._notification.success('Measurement Points Updated', 'This components measurement point has been updated.');

        this.dialogRef.close(result.m_Item1);
      } else {
        console.log(result.m_Item2);
        this._notification.error('Error', result.m_Item2);
      }
  }
  ngAfterViewInit() {
    this._loading.startLoading();
    this.addedTools = [];
    this.isLoading = true;
    this._subscriptions.push(this._measurementPointsService.getMeasurementTools().subscribe(result => {
      this.isLoading = false;
      this.trackTools = result;
      this.editingMeasurementPoint = this.data.measurementPointObj;
      this.makeId = this.data.makeId;
      this.allCalMethods = this.editingMeasurementPoint.CalculationMethods;
      this.editingMeasurementPoint.CalculationMethods.forEach(c => this.addAndremoveAddedToolsFromList(c.ToolId));
      this.allCalculations.assignAllCalculationMethods(this.editingMeasurementPoint.CalculationMethods);
      this.allCalculations.editingMeasurementPoint = this.editingMeasurementPoint;
      if (this.editingMeasurementPoint.CalculationMethods.length > 0) {
        this.setSelectedToolId(this.editingMeasurementPoint.CalculationMethods[0].ToolId);
      }
      this._loading.finishedLoading();
    }));

  }

  addAndremoveAddedToolsFromList(ToolId: number, ) {
    const implementedToolCal = this.trackTools.find(t => t.ToolId === ToolId);
    this.addedTools.push(implementedToolCal);
    const index = this.trackTools.findIndex(m => m.ToolId === ToolId);
    if (index !== -1) {// remove the implemented tools from list
      this.trackTools.splice(index, 1);
    }
  }

  addANewCalculationMethod(tool: MeasurementToolsViewModel) {
    this.addAndremoveAddedToolsFromList(tool.ToolId);
    const newCalculationMethod = new CalculationMethod();
    newCalculationMethod.ToolId = tool.ToolId;
    newCalculationMethod.MeasurementPointId = this.editingMeasurementPoint.MeasurementPonitId;
    newCalculationMethod.CompartId = this.editingMeasurementPoint.CompartId;
    newCalculationMethod.WornCalculationMethodTypeId = 2;
    newCalculationMethod.BugetLife = this.editingMeasurementPoint.BugetLife;
    newCalculationMethod.MakeId = this.makeId;
    this.allCalMethods.push(newCalculationMethod);
    this.setSelectedToolId(tool.ToolId);
    this.allCalculations.addNewToolToCalculation(newCalculationMethod);
  }

  setSelectedToolId(toolId: number) {
    this.selectedToolId = toolId;
    const selectedMethod = this.allCalMethods.find(c => c.ToolId === toolId);
    this.setCurrentSelectedMethod(selectedMethod);
  }

  setCurrentSelectedMethod(calculationMethod: CalculationMethod) {
    this.selectedCalculationMethodId = calculationMethod.CalculationMethodId;
    this.selectedCalculationMethodObj = calculationMethod;
    this.allCalculations.addNewToolToCalculation(this.selectedCalculationMethodObj);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
  saveAllCalculationMethods() {
    this.allCalculations.saveAllCalculationMethods();
  }

  private _userLanguage = 'english';

  translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }


}
